import React, { useEffect } from 'react';

import { FlexProps, Title } from '@mantine/core';
import { FullScreenAlert } from 'components/FullScreenAlert';
import { useTranslation } from 'react-i18next';
import { PosthogEvent, PosthogService } from 'services/posthog-service';

type ErrorAlertProps = FlexProps;

export function ErrorAlert({ ...flexProps }: ErrorAlertProps) {
  const { t } = useTranslation();

  useEffect(() => {
    PosthogService.capture(PosthogEvent.ERROR_ALERT_DISPLAYED);
  }, []);

  return (
    <FullScreenAlert
      header={
        <Title fz={70} mt="md">
          {t('ERROR_COMPONENT.CODE')}
        </Title>
      }
      notice={t('ERROR_COMPONENT.DESCRIPTION')}
      w="100%"
      h="100%"
      showLanguageChange={false}
      {...flexProps}
    />
  );
}
